import React, { useState, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './styling/sliderSatiata.css';

import image1 from './assets/sliderSatiata/1.jpg';
import image2 from './assets/sliderSatiata/2.jpg';
import image3 from './assets/sliderSatiata/3.jpg';
import image4 from './assets/sliderSatiata/4.jpg';
import image5 from './assets/sliderSatiata/5.jpg';
import image6 from './assets/sliderSatiata/6.jpg';
import image7 from './assets/sliderSatiata/7.jpg';
import image8 from './assets/sliderSatiata/8.jpg';
import image9 from './assets/sliderSatiata/9.jpg';
import image10 from './assets/sliderSatiata/10.jpg';
import image11 from './assets/sliderSatiata/11.jpg';
import image12 from './assets/sliderSatiata/12.jpg';
import image13 from './assets/sliderSatiata/13.jpg';
import image14 from './assets/sliderSatiata/14.jpg';

const ImageSliderSatiata = () => {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);

  const slider1 = useRef(null);
  const slider2 = useRef(null);

  const settingsMain = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    lazyLoad: 'ondemand', 
    arrows: false,
    responsive: [
      {
        breakpoint: 2024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5
        }
      },
      {
        breakpoint: 1624,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 1324,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,          
          arrows:true,
          dots:true,
        }
      }
    ],
  };


  const images = [
   
    image10,
    image11,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image1,
    image12,
    image13,
    image14
  ];

  return (
    <div data-aos="zoom-in-up" id='sliderBox'>
      {/* Main Image Slider */}
      <Slider
        {...settingsMain}
        ref={(slider) => setNav1(slider)}
        className="slider-for"
      >
        {images.map((image, index) => (
          <div key={index}>
            <img
              src={image}
              alt={`slide-${index}`}
              style={{ width: '100%', height: '600px', objectFit: 'cover' }}
            />
          </div>
        ))}
      </Slider>

      {/* Thumbnail Slider */}
      <Slider
        ref={(slider) => setNav2(slider)}
        className="slider-nav"
      >
        
      </Slider>
    </div>
  );
};

export default ImageSliderSatiata;
